import { ResponseDataList, ResponseDeviceType } from "@/types/service";
import { PaginationType } from "@/types/common";
import { HumpsUtils } from "@/utils";
import { ApiConstant } from "@/const";
import GlobalApi from "./config/api.config";

export type PayloadDeviceType = Pick<PaginationType, "page" | "size"> & Partial<ResponseDeviceType>;

export const getListDevice = async (payload: PayloadDeviceType) => {
  const response = await GlobalApi.toCamel().get<ResponseDataList<ResponseDeviceType>>(
    ApiConstant.GET_DEVICE_LIST,
    HumpsUtils.decamelizeKeys(payload),
  );
  if (response.ok && response.data) return response.data;
  throw response;
};
